var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSftAiPathIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 30,
    stroke: "#306CFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 23.4096L10.3336 26.7023L17 20.1162M7 10.2366C7 10.6733 7.17557 11.092 7.48808 11.4008C7.80059 11.7095 8.22444 11.883 8.6664 11.883H15.3336C15.5524 11.883 15.7691 11.8404 15.9713 11.7577C16.1735 11.6749 16.3572 11.5536 16.5119 11.4008C16.6667 11.2479 16.7894 11.0664 16.8732 10.8667C16.9569 10.6669 17 10.4528 17 10.2366V5.29688H7V10.2366Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSftAiPathIcon);
export default __webpack_public_path__ + "static/media/SftAiPathIcon.cf10104b3aa58a8a00494874658d9974.svg";
export { ForwardRef as ReactComponent };